import { getRemoteConfig, getValue } from 'firebase/remote-config';
import { firebaseApp } from 'firebaseConfig';
import { Auth0UserState } from 'hooks/useAuth0User';

export type FeatureFlag = 'DELIVERY_PORTAL';

const getDeliveryPortalFeatureFlag = (): { countries: string[] } => {
  const featureFlag = getValue(getRemoteConfig(firebaseApp), 'DELIVERY_PORTAL');
  return JSON.parse(featureFlag.asString());
};

const userCanAccessDeliveryPortal = (user: Auth0UserState): boolean => {
  const { countries } = getDeliveryPortalFeatureFlag();

  if (!user.isAuthenticated) {
    return false;
  }

  return countries.some(country => country === user.region);
};

/**
 * If flag is undefined, returns true
 * @param flag
 * @param user
 * @returns
 */
export const featureFlagIsTrue = (flag: FeatureFlag | undefined, user: Auth0UserState): boolean => {
  switch (flag) {
    case 'DELIVERY_PORTAL':
      return userCanAccessDeliveryPortal(user);
    default:
      return true;
  }
};
